module.exports = "/_next/static/images/ConstructionCardImage-090fb514465c877c5617604b996cc9c2.webp";